import { useEffect, useState } from "react";
import { X } from "lucide-react";
import VideoThumb from "./VideoThumb";

function vimeoEmbedUrl(link) {
  const m = String(link || "").match(/(\d{6,})/);
  return m ? `https://player.vimeo.com/video/${m[1]}?autoplay=1` : "";
}

export default function VideoDialog({ offen, onClose, titel = "Video", videoUrl }) {
  const url = videoUrl !== undefined ? videoUrl : process.env.REACT_APP_VIMEO_URL;
  const embedUrl = vimeoEmbedUrl(url);
  const [gestartet, setGestartet] = useState(false);

  useEffect(() => {
    setGestartet(false);
  }, [videoUrl, offen]);

  useEffect(() => {
    if (!offen) return;
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      window.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [offen, onClose]);

  if (!offen) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 px-4"
      data-testid="video-dialog"
      onClick={onClose}
    >
      <div className="relative w-full max-w-3xl" onClick={(e) => e.stopPropagation()}>
        <button
          type="button"
          data-testid="video-dialog-schliessen"
          aria-label="Schließen"
          onClick={onClose}
          className="absolute -top-11 right-0 flex h-9 w-9 items-center justify-center rounded-full bg-white/10 text-white transition-colors hover:bg-white/20"
        >
          <X size={20} />
        </button>
        <div className="aspect-video w-full overflow-hidden rounded-[2px] border border-white/15 bg-navy">
          {embedUrl && gestartet ? (
            <iframe
              src={embedUrl}
              className="h-full w-full"
              frameBorder="0"
              allow="autoplay; fullscreen; picture-in-picture"
              title={titel}
              allowFullScreen
            />
          ) : embedUrl ? (
            <VideoThumb
              videoUrl={url}
              onClick={() => setGestartet(true)}
              hinweis="Vorschaubild wird geladen ..."
              testid="video-dialog-vorschau"
              className="h-full w-full"
            />
          ) : (
            <div className="flex h-full flex-col items-center justify-center gap-4 px-6 text-center">
              <p className="text-base font-medium text-white">{titel}</p>
              <p className="text-sm text-hellblau" data-testid="video-dialog-hinweis">Das Video wird eingebunden, sobald der Vimeo-Link hinterlegt ist.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
